import React from 'react';
import { ReactComponent as EmptyIcon } from '../../../assets/svg/icons/empty-icon.svg';
import { getText } from '../../../helpers';
import history from '../../../utilities/history';
import './empty-state.style.scss';

interface EmptyStateProps {
    onViewHistory: () => void;
    wn: string;
}

function EmptyState({ onViewHistory, wn }: EmptyStateProps) {
    const langCode = getText('langCode');
    const handleViewHistory = () => {
        onViewHistory();
        const langCode = getText('langCode');
        history.push(`/${langCode}/support/whats-new`, { source: 'panel_empty_state' });
    };

    return (
        <div className={`${wn}__empty-state`}>
            <EmptyIcon className={`${wn}__empty-icon`} />
            <p className={`${wn}__empty-message`}>You&apos;ve seen all recent announcements.</p>
            <p className={`${wn}__empty-footer`}>
                View announcement history <button type="button" onClick={handleViewHistory}>here</button>.
            </p>
        </div>
    );
}

export default EmptyState;
